module.exports = __webpack_public_path__ + "static/media/yubikey-C.6913b36e.svg";